module.exports = __webpack_public_path__ + "static/media/especias.6e1b14b4.png";